export const REDIS_APP_KEY = 'app'
export const REDIS_HOMEPAGE_KEY = 'homepage'
export const REDIS_POPUP_KEY = 'popups'
